import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import "../VisorMartillo.css";

export interface IQVIARegistro {
  key: number;
  periodo: string;
  VSG: number;
  VResto: number;
  part: string;
  precio: number;
  precio_sg: number;
  descu: number;
  descu_sg: number;
}

const columns: ColumnsType<IQVIARegistro> = [
  { title: "Periodo", dataIndex: "periodo", key: "periodo" },
  { title: "VSG", dataIndex: "vsg", key: "vsg", align: "right" },
  { title: "VResto", dataIndex: "vresto", key: "vresto", align: "right" },
  { title: "Part%", dataIndex: "part", key: "part", align: "right" },
  { title: "Precio", dataIndex: "precio", key: "precio", align: "right" },
  { title: "PrecioSG", dataIndex: "preciosg", key: "preciosg", align: "right" },
  { title: "Descu", dataIndex: "descu", key: "descu", align: "right" },
  { title: "DesSG", dataIndex: "dessg", key: "dessg", align: "right" },
];

const Iqvia: React.FC<{ dataIqvia: IQVIARegistro[]; loader: boolean }> = ({ dataIqvia, loader }) => (
  <Table
    title={() => <div style={{ textAlign: "left", fontSize: "9px" }}>IQVIA</div>}
    className='custom-table-visor'
    columns={columns}
    dataSource={dataIqvia ? dataIqvia : []}
    size='small'
    bordered
    // scroll={{ x: 180, y: 60 }}
    scroll={{ x: 100, y: 60 }}
    loading={loader}
    pagination={false}
  />
);
export default Iqvia;
